<!-- 平台管理 - 按服务对象和服务项目分销任务管理 -->
<template>
    <div>
        <admin-main-header></admin-main-header>

        <div class="admin-main-body">
            <div
                class="admin-content"
                :style="{ minHeight: adminContentMinHeight + 'px' }"
            >
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 任务市场</span>
                    <span class="x-task-remark">自由接/发包市场</span>
                </div>
                <div class="admin-content-main">
                    <div class="el-search-form">
                        <el-form
                            ref="marketTaskQueryForm"
                            :model="marketTaskQueryForm"
                        >
                            <el-row :gutter="20">
                                <el-col :span="4" :offset="1">
                                    <el-form-item prop="taskName">
                                        <el-input
                                            v-model="
                                                marketTaskQueryForm.taskName
                                            "
                                            clearable
                                            placeholder="任务名称"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <template
                                    v-if="
                                        loginUser.userType == 0 ||
                                        marketTaskActiveTabName !== 'ALL'
                                    "
                                >
                                    <el-col :span="4">
                                        <el-form-item prop="status">
                                            <el-select
                                                v-model="
                                                    marketTaskQueryForm.status
                                                "
                                                clearable
                                                placeholder="任务状态"
                                                class="el-full-width"
                                            >
                                                <el-option
                                                    label="已创建"
                                                    :value="0"
                                                ></el-option>
                                                <el-option
                                                    label="已发包"
                                                    :value="1"
                                                ></el-option>
                                                <el-option
                                                    label="已接包"
                                                    :value="2"
                                                ></el-option>
                                                <el-option
                                                    label="已转包"
                                                    :value="3"
                                                ></el-option>
                                                <el-option
                                                    label="已完成"
                                                    :value="4"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-form-item prop="acceptStatus">
                                            <el-select
                                                v-model="
                                                    marketTaskQueryForm.acceptStatus
                                                "
                                                clearable
                                                placeholder="接包状态"
                                                class="el-full-width"
                                            >
                                                <el-option
                                                    label="未接包"
                                                    :value="0"
                                                ></el-option>
                                                <el-option
                                                    label="被接包"
                                                    :value="1"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-form-item prop="distributeStatus">
                                            <el-select
                                                v-model="
                                                    marketTaskQueryForm.distributeStatus
                                                "
                                                clearable
                                                placeholder="接包状态"
                                                class="el-full-width"
                                            >
                                                <el-option
                                                    label="未分派"
                                                    :value="0"
                                                ></el-option>
                                                <el-option
                                                    label="已分派"
                                                    :value="1"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </template>
                                <el-col :span="4">
                                    <el-form-item prop="serviceType">
                                        <el-select
                                            v-model="
                                                marketTaskQueryForm.serviceType
                                            "
                                            clearable
                                            placeholder="服务类型"
                                            class="el-full-width"
                                        >
                                            <el-option
                                                label="汽车服务"
                                                :value="1"
                                            ></el-option>
                                            <el-option
                                                label="市场营销"
                                                :value="2"
                                            ></el-option>
                                            <el-option
                                                label="车辆安全检测"
                                                :value="3"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item class="el-align-center">
                                        <el-button
                                            @click="resetMarketTaskQueryForm"
                                            icon="fas fa-undo"
                                            >重 置</el-button
                                        >&nbsp;&nbsp;&nbsp;&nbsp;
                                        <el-button
                                            type="primary"
                                            @click="queryMarketTaskList(1000)"
                                            icon="fas fa-search"
                                            >查 询
                                        </el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div
                        class="el-search-toolbar"
                        v-if="loginUser.userType != 0"
                    >
                        <el-button
                            type="primary"
                            size="small"
                            icon="fas fa-plus-circle"
                            @click="openMarketTaskEditDialog('add')"
                            >发布任务</el-button
                        >
                        <el-button
                            type="primary"
                            size="small"
                            icon="fas fa-upload"
                            @click="openMarketTaskImportDialog"
                            >批量发布</el-button
                        >
                    </div>
                    <el-tabs
                        v-model="marketTaskActiveTabName"
                        @tab-click="changeTaskTab"
                    >
                        <template v-for="(tab, index) in marketTaskTabOption">
                            <el-tab-pane
                                :label="tab.label"
                                :name="tab.name"
                                :key="index"
                            >
                                <div class="el-search-list">
                                    <el-table
                                        ref="marketTaskTable"
                                        v-loading="marketTaskQueryLoading"
                                        element-loading-text="拼命加载中..."
                                        element-loading-custom-class="el-loading-mask-opacity"
                                        :class="{
                                            loading: marketTaskQueryLoading,
                                        }"
                                        :data="marketTaskList"
                                        :default-sort="marketTaskQuerySort"
                                        @sort-change="
                                            onMarketTaskQuerySortChange
                                        "
                                        style="width: 100%"
                                        empty-text="暂无数据"
                                    >
                                        <el-table-column
                                            label="#"
                                            type="index"
                                            width="50"
                                            fixed
                                        ></el-table-column>
                                        <el-table-column
                                            label="任务名称"
                                            prop="taskName"
                                            width="180"
                                            align="center"
                                            sortable
                                            fixed
                                        >
                                            <template slot-scope="scope">
                                                <span>{{
                                                    scope.row.taskName
                                                }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="任务发布方"
                                            prop="sendUserId"
                                            width="220"
                                            sortable
                                        >
                                            <template slot-scope="scope">
                                                <div>
                                                    {{ scope.row.sendOrgName }}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="任务接受方"
                                            prop="acceptUserId"
                                            width="220"
                                            sortable
                                        >
                                            <template slot-scope="scope">
                                                <div>
                                                    {{
                                                        scope.row.acceptOrgName
                                                    }}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="服务对象"
                                            prop="taskServiceTargetCount"
                                            width="80"
                                            align="center"
                                        >
                                            <template slot-scope="scope">
                                                <el-button
                                                    v-if="
                                                        scope.row.status === 4
                                                    "
                                                    type="text"
                                                    @click="
                                                        openMarketTaskViewDialog(
                                                            'summary',
                                                            scope.row
                                                        )
                                                    "
                                                >
                                                    {{
                                                        scope.row
                                                            .taskServiceTargetCount
                                                    }}
                                                </el-button>
                                                <el-button
                                                    v-else
                                                    type="text"
                                                    @click="
                                                        openMarketTaskViewDialog(
                                                            'service',
                                                            scope.row
                                                        )
                                                    "
                                                >
                                                    {{
                                                        scope.row
                                                            .taskServiceTargetCount
                                                    }}
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="总金额"
                                            prop="totalAmount"
                                            width="140"
                                            align="center"
                                            sortable
                                        ></el-table-column>
                                        <el-table-column
                                            label="含税总金额"
                                            prop="totalTaxedAmount"
                                            width="140"
                                            align="center"
                                        ></el-table-column>
                                        <el-table-column
                                            label="税点"
                                            prop="taxThreshold"
                                            width="140"
                                            align="center"
                                            sortable
                                        ></el-table-column>
                                        <el-table-column
                                            label="任务状态"
                                            prop="status"
                                            width="140"
                                            sortable
                                        >
                                            <template slot-scope="scope">
                                                <el-tag
                                                    size="small"
                                                    effect="dark"
                                                    :type="
                                                        getMarketStatusTagType(
                                                            scope.row.status
                                                        )
                                                    "
                                                >
                                                    {{ scope.row.statusName }}
                                                </el-tag>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="接包状态"
                                            prop="acceptStatus"
                                            width="140"
                                            sortable
                                        >
                                            <template slot-scope="scope">
                                                <el-tag
                                                    size="small"
                                                    effect="dark"
                                                    :type="
                                                        getMarketTaskOtherStatusTagType(
                                                            scope.row
                                                                .acceptStatus
                                                        )
                                                    "
                                                >
                                                    {{
                                                        scope.row
                                                            .acceptStatusName
                                                    }}
                                                </el-tag>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="分派状态"
                                            prop="distributeStatus"
                                            width="140"
                                            sortable
                                        >
                                            <template slot-scope="scope">
                                                <el-tag
                                                    size="small"
                                                    effect="dark"
                                                    :type="
                                                        getMarketTaskOtherStatusTagType(
                                                            scope.row
                                                                .distributeStatus
                                                        )
                                                    "
                                                >
                                                    {{
                                                        scope.row
                                                            .distributeStatusName
                                                    }}
                                                </el-tag>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="是否作废"
                                            prop="distributeStatus"
                                            width="140"
                                            sortable
                                        >
                                            <template slot-scope="scope">
                                                <el-tag
                                                    size="small"
                                                    effect="dark"
                                                    :type="
                                                        getMarketTaskIsDeletedTagType(
                                                            scope.row.isDeleted
                                                        )
                                                    "
                                                >
                                                    {{
                                                        scope.row.isDeletedName
                                                    }}
                                                </el-tag>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="创建时间"
                                            prop="createTime"
                                            width="100"
                                            align="center"
                                            sortable
                                        ></el-table-column>
                                        <el-table-column
                                            label="操作"
                                            width="120"
                                            align="center"
                                            fixed="right"
                                        >
                                            <template slot-scope="scope">
                                                <el-button
                                                    v-if="
                                                        isPublishableMarketTask(
                                                            scope.row
                                                        )
                                                    "
                                                    class="task-consume-link"
                                                    type="text"
                                                    @click="
                                                        publishMarketTask(
                                                            scope.row
                                                        )
                                                    "
                                                    >发布任务
                                                </el-button>
                                                <el-button
                                                    v-else-if="
                                                        isAvailableMarketTask(
                                                            scope.row
                                                        )
                                                    "
                                                    class="task-consume-link"
                                                    type="text"
                                                    @click="
                                                        consumeMarketTask(
                                                            scope.row
                                                        )
                                                    "
                                                    >接受任务
                                                </el-button>
                                                <el-button
                                                    v-else-if="
                                                        isDistributableMarketTask(
                                                            scope.row
                                                        )
                                                    "
                                                    class="task-distribute-link"
                                                    type="text"
                                                    @click="
                                                        openMarketTaskDistributeDialog(
                                                            'distribute',
                                                            scope.row
                                                        )
                                                    "
                                                >
                                                    分派任务
                                                </el-button>
                                                <el-button
                                                    v-else
                                                    type="text"
                                                    @click="
                                                        openMarketTaskViewDialog(
                                                            'view',
                                                            scope.row
                                                        )
                                                    "
                                                >
                                                    查看任务
                                                </el-button>
                                                <el-dropdown
                                                    size="small"
                                                    trigger="click"
                                                    @command="
                                                        handleMarketTaskCommand(
                                                            arguments[0],
                                                            scope.row
                                                        )
                                                    "
                                                >
                                                    <span
                                                        class="el-dropdown-link"
                                                    >
                                                        <i
                                                            class="el-icon-arrow-down el-icon--right"
                                                        ></i>
                                                    </span>
                                                    <el-dropdown-menu
                                                        slot="dropdown"
                                                    >
                                                        <el-dropdown-item
                                                            command="view"
                                                            >查看任务</el-dropdown-item
                                                        >
                                                        <el-dropdown-item
                                                            v-if="
                                                                isPublishableMarketTask(
                                                                    scope.row
                                                                )
                                                            "
                                                            command="publish"
                                                            >发布任务
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                            v-if="
                                                                isModifiableMarketTask(
                                                                    scope.row
                                                                )
                                                            "
                                                            command="edit"
                                                        >
                                                            修改任务
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                            v-if="
                                                                isDeletableMarketTask(
                                                                    scope.row
                                                                )
                                                            "
                                                            command="cancel"
                                                            divided
                                                            >作废任务
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                            v-if="
                                                                isNoDeletableMarketTask(
                                                                    scope.row
                                                                )
                                                            "
                                                            command="noCancel"
                                                            divided
                                                            >取消作废
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                            v-if="
                                                                isAvailableMarketTask(
                                                                    scope.row
                                                                )
                                                            "
                                                            command="consume"
                                                        >
                                                            接受任务
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                            v-if="
                                                                isDistributableMarketTask(
                                                                    scope.row
                                                                )
                                                            "
                                                            command="distribute"
                                                            >分派任务
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                            v-if="
                                                                isUnDistributableMarketTask(
                                                                    scope.row
                                                                )
                                                            "
                                                            command="unDistribute"
                                                            >取消分派
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                            v-if="
                                                                isPublishableMarketTask2(
                                                                    scope.row
                                                                )
                                                            "
                                                            command="publish"
                                                            >转发任务
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                            v-if="
                                                                isModifiableMarketTask2(
                                                                    scope.row
                                                                )
                                                            "
                                                            command="edit2"
                                                        >
                                                            修改任务
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                            v-if="
                                                                isDistributableMarketTask(
                                                                    scope.row
                                                                )
                                                            "
                                                            command="unconsume"
                                                            divided
                                                            >取消接包
                                                        </el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div class="el-search-pager">
                                    <el-pagination
                                        background
                                        v-show="showMarketTaskQueryPager"
                                        @current-change="
                                            onMarketTaskQueryCurrentPageChange
                                        "
                                        :current-page.sync="
                                            marketTaskQueryForm.currentPage
                                        "
                                        :page-size="
                                            marketTaskQueryForm.pageSize
                                        "
                                        layout="slot, prev, pager, next, total"
                                        :total="marketTaskQueryTotal"
                                    >
                                        <div class="el-pagination-pagesize">
                                            <span class="first">每页显示</span>
                                            <el-button-group>
                                                <el-button
                                                    :class="{
                                                        active:
                                                            marketTaskQueryForm.pageSize ==
                                                            10,
                                                    }"
                                                    @click="
                                                        onMarketTaskQueryPageSizeChange(
                                                            10
                                                        )
                                                    "
                                                    >10
                                                </el-button>
                                                <el-button
                                                    :class="{
                                                        active:
                                                            marketTaskQueryForm.pageSize ==
                                                            20,
                                                    }"
                                                    @click="
                                                        onMarketTaskQueryPageSizeChange(
                                                            20
                                                        )
                                                    "
                                                    >20
                                                </el-button>
                                                <el-button
                                                    :class="{
                                                        active:
                                                            marketTaskQueryForm.pageSize ==
                                                            50,
                                                    }"
                                                    @click="
                                                        onMarketTaskQueryPageSizeChange(
                                                            50
                                                        )
                                                    "
                                                    >50
                                                </el-button>
                                                <el-button
                                                    :class="{
                                                        active:
                                                            marketTaskQueryForm.pageSize ==
                                                            100,
                                                    }"
                                                    @click="
                                                        onMarketTaskQueryPageSizeChange(
                                                            100
                                                        )
                                                    "
                                                    >100
                                                </el-button>
                                            </el-button-group>
                                            <span class="last">条</span>
                                        </div>
                                    </el-pagination>
                                </div>
                            </el-tab-pane>
                        </template>
                    </el-tabs>

                    <!-- 添加/修改Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="marketTaskEditDialogVisible"
                        @closed="closeMarketTaskEditDialog"
                        class="market-task"
                    >
                        <span slot="title" class="el-drawer-title">
                            {{ isEdit ? '修改任务' : '发布任务' }}</span
                        >

                        <div class="el-drawer-content">
                            <el-tabs
                                class="el-drawer-content-body"
                                v-model="marketTaskEditActiveTabName"
                            >
                                <el-tab-pane
                                    label="任务基本信息"
                                    name="marketTaskEditBasicInfo"
                                >
                                    <el-form
                                        class="el-drawer-content-body"
                                        ref="marketTaskEditForm"
                                        :model="marketTaskEditForm"
                                        :rules="marketTaskEditRules"
                                        label-width="120px"
                                    >
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item
                                                    label="任务名称"
                                                    prop="taskName"
                                                >
                                                    <el-col :span="12">
                                                        <el-input
                                                            v-model="
                                                                marketTaskEditForm.taskName
                                                            "
                                                            :disabled="
                                                                !canEditInfo
                                                            "
                                                            :maxlength="100"
                                                        ></el-input>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <p
                                                            class="el-form-item-tips"
                                                        >
                                                            不超过100个字符.
                                                        </p>
                                                    </el-col>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item
                                                    label="服务类型"
                                                    prop="serviceType"
                                                >
                                                    <el-col :span="12">
                                                        <el-select
                                                            v-model="
                                                                marketTaskEditForm.serviceType
                                                            "
                                                            :disabled="
                                                                !canEditInfo
                                                            "
                                                            clearable
                                                            class="el-full-width"
                                                        >
                                                            <el-option
                                                                label="汽车服务"
                                                                :value="1"
                                                            ></el-option>
                                                            <el-option
                                                                label="市场营销"
                                                                :value="2"
                                                            ></el-option>
                                                            <el-option
                                                                label="车辆安全检测"
                                                                :value="3"
                                                            ></el-option>
                                                        </el-select>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <p
                                                            class="el-form-item-tips"
                                                        ></p>
                                                    </el-col>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item
                                                    label="金额"
                                                    prop="totalAmount"
                                                >
                                                    <el-col :span="12">
                                                        <el-input
                                                            v-model="
                                                                marketTaskEditForm.totalAmount
                                                            "
                                                            :disabled="
                                                                !canEditInfo
                                                            "
                                                            :maxlength="10"
                                                        ></el-input>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <p
                                                            class="el-form-item-tips"
                                                        >
                                                            金额最多允许2位小数
                                                        </p>
                                                    </el-col>
                                                </el-form-item>
                                            </el-col>
                                            <el-col
                                                :span="12"
                                                v-if="canEditInfo"
                                            >
                                                <el-form-item
                                                    label="金额区间"
                                                    prop="amountRange"
                                                >
                                                    <el-col :span="12">
                                                        <el-input
                                                            v-model="
                                                                marketTaskEditForm.amountRange
                                                            "
                                                            :maxlength="50"
                                                        ></el-input>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <p
                                                            class="el-form-item-tips"
                                                        >
                                                            例如：750-800
                                                        </p>
                                                    </el-col>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item
                                                    label="税点"
                                                    prop="taxThreshold"
                                                >
                                                    <el-col :span="12">
                                                        <el-input
                                                            v-model="
                                                                marketTaskEditForm.taxThreshold
                                                            "
                                                            :maxlength="6"
                                                        ></el-input>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <p
                                                            class="el-form-item-tips"
                                                        >
                                                            税点最多允许2位小数
                                                        </p>
                                                    </el-col>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item
                                                    label="含税金额"
                                                    prop="totalTaxedAmount"
                                                >
                                                    <el-col :span="12">
                                                        <el-input
                                                            v-model="
                                                                marketTaskEditForm.totalTaxedAmount
                                                            "
                                                            :maxlength="10"
                                                            readonly
                                                            disabled
                                                        ></el-input>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <p
                                                            class="el-form-item-tips"
                                                        >
                                                            含税金额 = 金额 *
                                                            ((100 + 税点) / 100)
                                                        </p>
                                                    </el-col>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                </el-tab-pane>
                                <el-tab-pane
                                    label="任务服务明细"
                                    name="marketTaskViewServiceDetail"
                                    v-if="isEdit"
                                >
                                    <div
                                        class="el-search-pager el-padding-no el-clearfix"
                                    >
                                        <el-dropdown
                                            class="el-float-left"
                                            style="margin-bottom: 10px"
                                            size="small"
                                            trigger="click"
                                            placement="bottom-start"
                                            :disabled="
                                                submiting ||
                                                !marketTaskViewForm.taskId
                                            "
                                            :loading="submiting"
                                            @command="exportTaskDetails"
                                        >
                                            <el-button
                                                size="small"
                                                icon="fas fa-download"
                                                :loading="exportLoading"
                                                type="primary"
                                            >
                                                导出清单<i
                                                    class="el-icon-arrow-down el-icon--right"
                                                ></i>
                                            </el-button>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item
                                                    command="2"
                                                    v-if="!isTopOrg"
                                                    >导出清单(报价)</el-dropdown-item
                                                >
                                                <el-dropdown-item command="1"
                                                    >导出清单(成本)</el-dropdown-item
                                                >
                                            </el-dropdown-menu>
                                        </el-dropdown>

                                        <el-pagination
                                            class="el-padding-no"
                                            background
                                            @current-change="
                                                onTaskServiceDetailQueryPageChange
                                            "
                                            :current-page.sync="
                                                taskServiceDetailQueryForm.currentPage
                                            "
                                            :page-size="
                                                taskServiceDetailQueryForm.pageSize
                                            "
                                            layout="prev, pager, next, total, slot"
                                            :total="taskServiceDetailTotal"
                                        >
                                            <div class="el-pagination-pagesize">
                                                <span class="first"
                                                    >每页显示</span
                                                >
                                                <el-button-group>
                                                    <el-button
                                                        :class="{
                                                            active:
                                                                taskServiceDetailQueryForm.pageSize ==
                                                                10,
                                                        }"
                                                        @click="
                                                            onTaskServiceDetailQueryPageSizeChange(
                                                                10
                                                            )
                                                        "
                                                        >10
                                                    </el-button>
                                                    <el-button
                                                        :class="{
                                                            active:
                                                                taskServiceDetailQueryForm.pageSize ==
                                                                20,
                                                        }"
                                                        @click="
                                                            onTaskServiceDetailQueryPageSizeChange(
                                                                20
                                                            )
                                                        "
                                                        >20
                                                    </el-button>
                                                    <el-button
                                                        :class="{
                                                            active:
                                                                taskServiceDetailQueryForm.pageSize ==
                                                                50,
                                                        }"
                                                        @click="
                                                            onTaskServiceDetailQueryPageSizeChange(
                                                                50
                                                            )
                                                        "
                                                        >50
                                                    </el-button>
                                                    <el-button
                                                        :class="{
                                                            active:
                                                                taskServiceDetailQueryForm.pageSize ==
                                                                100,
                                                        }"
                                                        @click="
                                                            onTaskServiceDetailQueryPageSizeChange(
                                                                100
                                                            )
                                                        "
                                                        >100
                                                    </el-button>
                                                </el-button-group>
                                                <span class="last">条</span>
                                            </div>
                                        </el-pagination>
                                    </div>
                                    <div class="el-search-list">
                                        <el-table
                                            :data="taskServiceDetail"
                                            v-loading="
                                                taskServiceTargetsLoading
                                            "
                                            element-loading-text="拼命加载中..."
                                            element-loading-custom-class="el-loading-mask-opacity"
                                            :class="{
                                                loading:
                                                    taskServiceTargetsLoading,
                                            }"
                                            style="width: 100%"
                                            :max-height="
                                                marketTaskViewTableHeight
                                            "
                                            class="el-form-item-table"
                                        >
                                            <el-table-column
                                                label="#"
                                                type="index"
                                                width="40"
                                            ></el-table-column>
                                            <el-table-column
                                                :label="
                                                    serviceType != 1
                                                        ? '服务对象'
                                                        : '车主姓名'
                                                "
                                                prop="targetName"
                                                width="100"
                                            >
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        scope.row.targetName
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                v-if="serviceType == 1"
                                                label="车牌号码"
                                                prop="plateNumber"
                                                width="100"
                                            >
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        scope.row.plateNumber
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                v-if="serviceType == 1"
                                                label="车辆品牌型号"
                                                prop="vehicleModel"
                                                width="200"
                                            >
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        scope.row.vehicleModel
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                v-if="serviceType == 1"
                                                label="车架号"
                                                prop="vehicleVin"
                                                width="120"
                                            >
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        scope.row.vehicleVin
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                label="服务明细"
                                                prop="taskServiceDetails"
                                            >
                                                <template slot-scope="scope">
                                                    <el-tag
                                                        size="small"
                                                        class="task-service-detail-tag"
                                                        v-for="serviceDetail in scope
                                                            .row
                                                            .taskServiceDetails"
                                                        :key="
                                                            serviceDetail.serviceId
                                                        "
                                                        type="primay"
                                                    >
                                                        {{
                                                            serviceDetail.serviceName
                                                        }}({{
                                                            serviceDetail.servicePrice
                                                        }}{{
                                                            serviceDetail.priceUnit
                                                        }}) x
                                                        {{
                                                            serviceDetail.serviceCount
                                                        }}
                                                    </el-tag>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                label="服务费小计"
                                                prop="subTotalAmounts"
                                                width="100"
                                            >
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        scope.row
                                                            .subTotalAmounts
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeMarketTaskEditDialog"
                                    >取 消</el-button
                                >
                                <el-button
                                    v-if="
                                        marketTaskEditActiveTabName ===
                                        'marketTaskEditBasicInfo'
                                    "
                                    type="primary"
                                    icon="far fa-save"
                                    @click="saveMarketTask"
                                    :loading="submiting"
                                    >确 定</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 导入Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="marketTaskImportDialogVisible"
                        @closed="closeMarketTaskImportDialog"
                    >
                        <span slot="title" class="el-drawer-title"
                            >批量分派任务</span
                        >
                        <div class="el-drawer-content">
                            <el-form
                                class="el-drawer-content-body"
                                v-custom-validator-apply="marketTaskImportRules"
                                ref="marketTaskImportForm"
                                :model="marketTaskImportForm"
                                :rules="marketTaskImportRules"
                                label-width="300px"
                            >
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="上传EXCEL文件"
                                            prop="uploadExcelFilePath"
                                        >
                                            <el-col :span="12">
                                                <el-upload
                                                    class="upload-excel"
                                                    ref="marketTaskImportUploader"
                                                    name="uploadFile"
                                                    :multiple="false"
                                                    :limit="1"
                                                    :on-exceed="
                                                        handleImportExcelExceed
                                                    "
                                                    :headers="uploadHeaders"
                                                    :action="
                                                        importExcelUploadUrl
                                                    "
                                                    :data="
                                                        importExcelUploadParam
                                                    "
                                                    :before-upload="
                                                        beforeImportExcelUpload
                                                    "
                                                    :on-remove="
                                                        handleImportExcelRemove
                                                    "
                                                    :on-success="
                                                        handleImportExcelUploadSuccess
                                                    "
                                                    :on-error="
                                                        handleUploadError
                                                    "
                                                >
                                                    <el-button
                                                        slot="trigger"
                                                        size="small"
                                                        type="primary"
                                                        icon="fas fa-plus-circle"
                                                        >选择文件</el-button
                                                    >
                                                    <a
                                                        class="excel-template"
                                                        href="javascript:;"
                                                        @click="
                                                            downloadTemplateExcel
                                                        "
                                                        >下载模板</a
                                                    >
                                                    <div
                                                        class="el-upload__tip"
                                                        slot="tip"
                                                    >
                                                        只能上传xls|xlsx格式的EXCEL文件，大小不超过1MB!
                                                    </div>
                                                </el-upload>
                                                <div
                                                    v-if="
                                                        showMarketTaskImportFeedback
                                                    "
                                                >
                                                    <p class="import-feedback">
                                                        上传EXCEL中部分数据校验不通过，请点此
                                                        <a
                                                            href="javascript:;"
                                                            @click="
                                                                downloadFeedbackExcel
                                                            "
                                                            >链接下载</a
                                                        >
                                                        反馈信息予以更正并重新上传导入.
                                                    </p>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeMarketTaskImportDialog"
                                    >取 消</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="far fa-save"
                                    @click="importMarketTask"
                                    :loading="importing"
                                    >确 定</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 分派Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="marketTaskDistributeDialogVisible"
                        @closed="closeMarketTaskDistributeDialog"
                    >
                        <span slot="title" class="el-drawer-title">
                            分派任务【{{
                                marketTaskDistributeForm.taskObj.taskName
                            }}】</span
                        >
                        <div class="el-drawer-content">
                            <el-form
                                class="el-drawer-content-body"
                                v-custom-validator-apply="
                                    marketTaskDistributeRules
                                "
                                ref="marketTaskDistributeForm"
                                :model="marketTaskDistributeForm"
                                :rules="marketTaskDistributeRules"
                                label-width="300px"
                                label-suffix="："
                            >
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="服务类型">
                                            <el-col :span="12">
                                                {{
                                                    marketTaskDistributeForm
                                                        .taskObj.serviceTypeName
                                                }}
                                            </el-col>
                                            <el-col :span="12"> </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="任务发布方">
                                            <el-col :span="12">
                                                {{
                                                    marketTaskDistributeForm
                                                        .taskObj.sendOrgName
                                                }}
                                            </el-col>
                                            <el-col :span="12"> </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="任务接受方">
                                            <el-col :span="12">
                                                {{
                                                    marketTaskDistributeForm
                                                        .taskObj.acceptOrgName
                                                }}
                                            </el-col>
                                            <el-col :span="12"> </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="任务总金额">
                                            <el-col :span="12">
                                                {{
                                                    marketTaskDistributeForm
                                                        .taskObj.totalAmount
                                                }}
                                            </el-col>
                                            <el-col :span="12"> </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="服务对象数">
                                            <el-col :span="12">
                                                {{
                                                    marketTaskDistributeForm
                                                        .taskObj
                                                        .taskServiceTargetCount
                                                }}
                                            </el-col>
                                            <el-col :span="12"> </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="分派团队长"
                                            prop="leaderStaffId"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        marketTaskDistributeForm.leaderStaffId
                                                    "
                                                    placeholder="团队长(支持名称或身份证模糊搜索)"
                                                    clearable
                                                    filterable
                                                    remote
                                                    :remote-method="
                                                        loadLeaderStaffs
                                                    "
                                                    :loading="
                                                        leaderStaffQueryLoading
                                                    "
                                                    @clear="
                                                        clearLeaderStaffQuerySelectOptions
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in leaderStaffQuerySelectOptions"
                                                        :key="item.staffId"
                                                        :label="item.staffName"
                                                        :value="item.staffId"
                                                        class="leader-select-option"
                                                    >
                                                        <span
                                                            class="option-left"
                                                            >{{
                                                                item.idcard
                                                            }}</span
                                                        >
                                                        <span
                                                            class="option-right"
                                                            >{{
                                                                item.staffName
                                                            }}</span
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div
                                class="el-drawer-content-footer"
                                style="padding: 15px 0"
                            >
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeMarketTaskDistributeDialog"
                                    >关 闭</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="far fa-save"
                                    @click="distributeMarketTask"
                                    :loading="submiting"
                                    >确 定
                                </el-button>
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 查看Dialog -->
                    <el-drawer
                        :with-header="false"
                        size="80%"
                        :visible.sync="marketTaskViewDialogVisible"
                        @closed="closeMarketTaskViewDialog"
                    >
                        <div class="el-drawer-content">
                            <el-tabs
                                class="el-drawer-content-body"
                                v-model="marketTaskViewActiveTabName"
                            >
                                <el-tab-pane
                                    label="任务基本信息"
                                    name="marketTaskViewBasicInfo"
                                >
                                    <el-form
                                        class="el-form-detail"
                                        inline
                                        label-position="right"
                                        label-width="120px"
                                        label-suffix="："
                                    >
                                        <el-form-item label="任务ID">{{
                                            marketTaskViewForm.taskId
                                        }}</el-form-item>
                                        <el-form-item label="任务名称">{{
                                            marketTaskViewForm.taskName
                                        }}</el-form-item>

                                        <el-form-item label="服务类型"
                                            >{{
                                                marketTaskViewForm.serviceTypeName
                                            }}
                                        </el-form-item>
                                        <el-form-item label="总金额">{{
                                            marketTaskViewForm.totalAmount
                                        }}</el-form-item>

                                        <template v-if="!isAll">
                                            <el-form-item label="税点">{{
                                                marketTaskViewForm.taxThreshold
                                            }}</el-form-item>
                                            <el-form-item label="含税总金额">{{
                                                marketTaskViewForm.totalTaxedAmount
                                            }}</el-form-item>
                                        </template>

                                        <el-form-item label="任务发布方">{{
                                            marketTaskViewForm.sendOrgName
                                        }}</el-form-item>
                                        <el-form-item label="任务发布者">{{
                                            marketTaskViewForm.sendUserName
                                        }}</el-form-item>

                                        <el-form-item label="任务接受方"
                                            >{{
                                                marketTaskViewForm.acceptOrgName
                                            }}
                                        </el-form-item>
                                        <el-form-item label="任务接受者"
                                            >{{
                                                marketTaskViewForm.acceptUserName
                                            }}
                                        </el-form-item>

                                        <el-form-item label="任务状态">
                                            <el-tag
                                                size="small"
                                                effect="dark"
                                                :type="
                                                    getMarketStatusTagType(
                                                        marketTaskViewForm.status
                                                    )
                                                "
                                            >
                                                {{
                                                    marketTaskViewForm.statusName
                                                }}
                                            </el-tag>
                                        </el-form-item>
                                        <el-form-item label="接包状态">
                                            <el-tag
                                                size="small"
                                                effect="dark"
                                                :type="
                                                    getMarketTaskOtherStatusTagType(
                                                        marketTaskViewForm.acceptStatus
                                                    )
                                                "
                                            >
                                                {{
                                                    marketTaskViewForm.acceptStatusName
                                                }}
                                            </el-tag>
                                        </el-form-item>

                                        <el-form-item label="分派状态">
                                            <el-tag
                                                size="small"
                                                effect="dark"
                                                :type="
                                                    getMarketTaskOtherStatusTagType(
                                                        marketTaskViewForm.distributeStatus
                                                    )
                                                "
                                            >
                                                {{
                                                    marketTaskViewForm.distributeStatusName
                                                }}
                                            </el-tag>
                                        </el-form-item>
                                        <el-form-item label="任务分派时间"
                                            >{{
                                                marketTaskViewForm.distributeTime
                                            }}
                                        </el-form-item>

                                        <el-form-item label="创建时间">{{
                                            marketTaskViewForm.createTime
                                        }}</el-form-item>
                                        <el-form-item label="修改时间">{{
                                            marketTaskViewForm.updateTime
                                        }}</el-form-item>
                                    </el-form>
                                </el-tab-pane>
                                <el-tab-pane
                                    label="任务服务明细"
                                    name="marketTaskViewServiceDetail"
                                >
                                    <div
                                        class="el-search-pager el-padding-no el-clearfix"
                                    >
                                        <template v-if="!isAll">
                                            <el-dropdown
                                                class="el-float-left"
                                                style="margin-bottom: 10px"
                                                size="small"
                                                trigger="click"
                                                placement="bottom-start"
                                                :disabled="
                                                    submiting ||
                                                    !marketTaskViewForm.taskId
                                                "
                                                :loading="submiting"
                                                @command="exportTaskDetails"
                                            >
                                                <el-button
                                                    size="small"
                                                    icon="fas fa-download"
                                                    :loading="exportLoading"
                                                    type="primary"
                                                >
                                                    导出清单<i
                                                        class="el-icon-arrow-down el-icon--right"
                                                    ></i>
                                                </el-button>
                                                <el-dropdown-menu
                                                    slot="dropdown"
                                                >
                                                    <el-dropdown-item
                                                        :command="2"
                                                        v-if="!isTopOrg"
                                                        >导出清单(报价)</el-dropdown-item
                                                    >
                                                    <el-dropdown-item
                                                        :command="1"
                                                        >导出清单(成本)</el-dropdown-item
                                                    >
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </template>

                                        <el-pagination
                                            class="el-padding-no"
                                            background
                                            @current-change="
                                                onTaskServiceDetailQueryPageChange
                                            "
                                            :current-page.sync="
                                                taskServiceDetailQueryForm.currentPage
                                            "
                                            :page-size="
                                                taskServiceDetailQueryForm.pageSize
                                            "
                                            layout="prev, pager, next, total, slot"
                                            :total="taskServiceDetailTotal"
                                        >
                                            <div class="el-pagination-pagesize">
                                                <span class="first"
                                                    >每页显示</span
                                                >
                                                <el-button-group>
                                                    <el-button
                                                        :class="{
                                                            active:
                                                                taskServiceDetailQueryForm.pageSize ==
                                                                10,
                                                        }"
                                                        @click="
                                                            onTaskServiceDetailQueryPageSizeChange(
                                                                10
                                                            )
                                                        "
                                                        >10
                                                    </el-button>
                                                    <el-button
                                                        :class="{
                                                            active:
                                                                taskServiceDetailQueryForm.pageSize ==
                                                                20,
                                                        }"
                                                        @click="
                                                            onTaskServiceDetailQueryPageSizeChange(
                                                                20
                                                            )
                                                        "
                                                        >20
                                                    </el-button>
                                                    <el-button
                                                        :class="{
                                                            active:
                                                                taskServiceDetailQueryForm.pageSize ==
                                                                50,
                                                        }"
                                                        @click="
                                                            onTaskServiceDetailQueryPageSizeChange(
                                                                50
                                                            )
                                                        "
                                                        >50
                                                    </el-button>
                                                    <el-button
                                                        :class="{
                                                            active:
                                                                taskServiceDetailQueryForm.pageSize ==
                                                                100,
                                                        }"
                                                        @click="
                                                            onTaskServiceDetailQueryPageSizeChange(
                                                                100
                                                            )
                                                        "
                                                        >100
                                                    </el-button>
                                                </el-button-group>
                                                <span class="last">条</span>
                                            </div>
                                        </el-pagination>
                                    </div>

                                    <div class="el-search-list">
                                        <el-table
                                            :data="taskServiceDetail"
                                            v-loading="
                                                taskServiceTargetsLoading
                                            "
                                            element-loading-text="拼命加载中..."
                                            element-loading-custom-class="el-loading-mask-opacity"
                                            :class="{
                                                loading:
                                                    taskServiceTargetsLoading,
                                            }"
                                            style="width: 100%"
                                            :max-height="
                                                marketTaskViewTableHeight
                                            "
                                            class="el-form-item-table"
                                        >
                                            <el-table-column
                                                label="#"
                                                type="index"
                                                width="40"
                                            ></el-table-column>
                                            <el-table-column
                                                :label="
                                                    serviceType != 1
                                                        ? '服务对象'
                                                        : '车主姓名'
                                                "
                                                prop="targetName"
                                                width="100"
                                            >
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        scope.row.targetName
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                v-if="serviceType == 1"
                                                label="车牌号码"
                                                prop="plateNumber"
                                                width="100"
                                            >
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        scope.row.plateNumber
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                v-if="serviceType == 1"
                                                label="车辆品牌型号"
                                                prop="vehicleModel"
                                                width="200"
                                            >
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        scope.row.vehicleModel
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                v-if="serviceType == 1"
                                                label="车架号"
                                                prop="vehicleVin"
                                                width="120"
                                            >
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        scope.row.vehicleVin
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                label="服务明细"
                                                prop="taskServiceDetails"
                                            >
                                                <template slot-scope="scope">
                                                    <el-tag
                                                        size="small"
                                                        class="task-service-detail-tag"
                                                        v-for="serviceDetail in scope
                                                            .row
                                                            .taskServiceDetails"
                                                        :key="
                                                            serviceDetail.serviceId
                                                        "
                                                        type="primay"
                                                    >
                                                        {{
                                                            serviceDetail.serviceName
                                                        }}({{
                                                            serviceDetail.servicePrice
                                                        }}{{
                                                            serviceDetail.priceUnit
                                                        }}) x
                                                        {{
                                                            serviceDetail.serviceCount
                                                        }}
                                                    </el-tag>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                label="服务费小计"
                                                prop="subTotalAmounts"
                                                width="100"
                                            >
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        scope.row
                                                            .subTotalAmounts
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane
                                    v-if="detailShowDistribute"
                                    label="任务分派清单"
                                    name="marketTaskViewSummary"
                                >
                                    <div
                                        class="el-search-pager el-padding-no el-clearfix"
                                    >
                                        <el-pagination
                                            class="el-padding-no"
                                            background
                                            v-show="showTaskDistribQueryPager"
                                            @current-change="
                                                onTaskDistribQueryPageChange
                                            "
                                            :current-page.sync="
                                                taskDistributeDetailQueryForm.currentPage
                                            "
                                            :page-size="
                                                taskDistributeDetailQueryForm.pageSize
                                            "
                                            layout="prev, pager, next, total, slot"
                                            :total="taskDistributeDetailTotal"
                                        >
                                            <div class="el-pagination-pagesize">
                                                <span class="first"
                                                    >每页显示</span
                                                >
                                                <el-button-group>
                                                    <el-button
                                                        :class="{
                                                            active:
                                                                taskDistributeDetailQueryForm.pageSize ==
                                                                10,
                                                        }"
                                                        @click="
                                                            onTaskDistribQueryPageSizeChange(
                                                                10
                                                            )
                                                        "
                                                        >10
                                                    </el-button>
                                                    <el-button
                                                        :class="{
                                                            active:
                                                                taskDistributeDetailQueryForm.pageSize ==
                                                                20,
                                                        }"
                                                        @click="
                                                            onTaskDistribQueryPageSizeChange(
                                                                20
                                                            )
                                                        "
                                                        >20
                                                    </el-button>
                                                    <el-button
                                                        :class="{
                                                            active:
                                                                taskDistributeDetailQueryForm.pageSize ==
                                                                50,
                                                        }"
                                                        @click="
                                                            onTaskDistribQueryPageSizeChange(
                                                                50
                                                            )
                                                        "
                                                        >50
                                                    </el-button>
                                                    <el-button
                                                        :class="{
                                                            active:
                                                                taskDistributeDetailQueryForm.pageSize ==
                                                                100,
                                                        }"
                                                        @click="
                                                            onTaskDistribQueryPageSizeChange(
                                                                100
                                                            )
                                                        "
                                                        >100
                                                    </el-button>
                                                </el-button-group>
                                                <span class="last">条</span>
                                            </div>
                                        </el-pagination>
                                    </div>
                                    <div class="el-search-list">
                                        <el-table
                                            ref="taskServiceTable"
                                            v-loading="
                                                taskDistributeDetailsLoading
                                            "
                                            element-loading-text="拼命加载中..."
                                            element-loading-custom-class="el-loading-mask-opacity"
                                            :class="{
                                                loading:
                                                    taskDistributeDetailsLoading,
                                            }"
                                            :data="taskDistributeDetailList"
                                            style="width: 100%"
                                            :max-height="
                                                marketTaskViewTableHeight
                                            "
                                            class="el-table-overflow-x-hidden"
                                            empty-text="暂无数据"
                                        >
                                            <el-table-column
                                                label="#"
                                                type="index"
                                                width="50"
                                            ></el-table-column>
                                            <el-table-column
                                                label="服务对象"
                                                prop="serviceTargetName"
                                                width="150"
                                                align="center"
                                            ></el-table-column>
                                            <el-table-column
                                                label="服务标的"
                                                prop="targetPlateNumber"
                                                width="120"
                                                align="center"
                                            ></el-table-column>
                                            <el-table-column
                                                label="服务金额"
                                                prop="serviceAmounts"
                                                width="120"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <el-popover
                                                        placement="top"
                                                        trigger="hover"
                                                    >
                                                        <ul
                                                            class="task-service-details"
                                                        >
                                                            <li
                                                                v-for="(
                                                                    serviceDetail,
                                                                    index
                                                                ) in scope.row
                                                                    .taskServiceDetails"
                                                                :key="index"
                                                            >
                                                                <span
                                                                    class="name"
                                                                    >{{
                                                                        serviceDetail.serviceName
                                                                    }}</span
                                                                >：<span
                                                                    >{{
                                                                        serviceDetail.servicePrice
                                                                    }}{{
                                                                        serviceDetail.priceUnit
                                                                    }}
                                                                    x
                                                                    {{
                                                                        serviceDetail.serviceCount
                                                                    }}</span
                                                                >
                                                            </li>
                                                        </ul>
                                                        <el-button
                                                            type="text"
                                                            slot="reference"
                                                        >
                                                            {{
                                                                scope.row
                                                                    .serviceAmounts
                                                            }}
                                                        </el-button>
                                                    </el-popover>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                label="服务机构"
                                                prop="produceOrgName"
                                                align="center"
                                            ></el-table-column>
                                            <el-table-column
                                                label="团队长"
                                                prop="leaderStaffName"
                                                width="180"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <div>
                                                        {{
                                                            scope.row
                                                                .leaderStaffName
                                                        }}
                                                    </div>
                                                    <div class="idcard">
                                                        {{
                                                            scope.row
                                                                .leaderStaffIdcard
                                                        }}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                label="服务人员"
                                                prop="serviceStaffName"
                                                width="180"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <div>
                                                        {{
                                                            scope.row
                                                                .serviceStaffName
                                                        }}
                                                    </div>
                                                    <div class="idcard">
                                                        {{
                                                            scope.row
                                                                .serviceStaffIdcard
                                                        }}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                label="服务日期"
                                                prop="distributeDate"
                                                width="120"
                                                align="center"
                                            ></el-table-column>
                                        </el-table>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                            <div
                                class="el-drawer-content-footer"
                                style="padding: 15px 0"
                            >
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeMarketTaskViewDialog"
                                    >关 闭</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
        </div>

        <el-dialog
            :visible.sync="isChoseOrg"
            title="指定接包机构"
            class="el-dialog-center"
            width="40%"
            @close="closeChoseOrg"
        >
            <el-form
                class="el-drawer-content-body"
                ref="publishForm"
                :model="publishForm"
                label-width="120px"
            >
                <el-form-item prop="orgId" label="接包机构">
                    <el-select
                        v-model="publishForm.orgId"
                        placeholder="请选择"
                        clearable
                        filterable
                        class="el-full-width"
                    >
                        <el-option
                            v-for="(item, index) in chooseOrgList"
                            :key="index"
                            :label="item.orgName"
                            :value="item.orgId"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="el-drawer-content-footer">
                <el-button
                    icon="fas fa-ban"
                    @click="closeChoseOrg"
                    :loading="submiting"
                    >取 消</el-button
                >
                <el-button
                    type="primary"
                    icon="far fa-save"
                    @click="publish"
                    :loading="submiting"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { mapSort, deepClone, randomCode, parseFilename } from '@/utils.js';
import FileSaver from 'file-saver';
import { WINDOW_HEIGHT } from '@/constants.js';
import { ALL_ORG_ID, TARGET_MAX_SERVICE_AMOUNT } from '@/visp.js';

const EXCEL_TYPES = ['xls', 'xlsx'];
const TAX_THRESHOLD_PATTERN = /^([0-9])+(\.[0-9]{1,2})?$/;

export default {
    name: 'MarketDistribTask',
    data() {
        return {
            marketTaskTabOption: [
                {
                    label: '全部',
                    name: 'ALL',
                },
                {
                    label: '我的',
                    name: 'MY',
                },
            ],
            marketTaskActiveTabName: 'ALL',

            // 任务列表
            submiting: false,
            allOrgList: [],
            orgSelectFilterQuery: '',
            leaderStaffQueryLoading: false,
            leaderStaffQuerySelectOptions: [],
            //任务模块
            marketTaskQueryLoading: false,
            marketTaskQuering: false,
            marketTaskQueryForm: {
                taskName: '',
                taskQueryType: 'ALL',
                status: '',
                acceptStatus: '',
                distributeStatus: '',
                serviceType: '',
                pageSize: 10,
                currentPage: 1,
            },
            marketTaskList: [],
            marketTaskQueryTotal: 0,
            marketTaskQuerySort: {
                prop: 'taskId',
                order: 'descending',
            },

            // 指定接包机构
            isChoseOrg: false,
            publishForm: {
                taskId: null,
                orgId: null,
                tradeOrgIds: [],
            },

            // 编辑任务
            marketTaskEditDialogVisible: false,
            marketTaskEditActiveTabName: 'marketTaskEditBasicInfo',
            marketTaskCurrentActionType: '',
            canEditInfo: false,
            marketTaskEditForm: {
                taskId: '',
                taskName: '',
                serviceType: '',
                totalAmount: '0',
                amountRange: '750-800',
                taxThreshold: '0',
                totalTaxedAmount: '0',
                ownerId: '',
                ownerOrgId: '',
                tradeOrgIds: [],
            },
            marketTaskEditRules: {
                serviceType: [
                    {
                        required: true,
                        message: '请选择服务类型!',
                    },
                ],
                totalAmount: [
                    {
                        required: true,
                        message: '请输入金额!',
                    },
                    {
                        pattern: TAX_THRESHOLD_PATTERN,
                        message: '金额必须是非负数且小数部分至多2位!',
                    },
                ],
                taxThreshold: [
                    {
                        required: true,
                        message: '请输入税点!',
                    },
                    {
                        pattern: TAX_THRESHOLD_PATTERN,
                        message: '税点必须是非负数且小数部分至多2位!',
                    },
                ],
            },

            // 批量导入
            marketTaskImportDialogVisible: false,
            showMarketTaskImportFeedback: false,
            importExcelUploadUrl: PLATFORM_API.of(
                '/api/xupload/protected/file'
            ),
            importExcelUploadParam: {
                renameStrategy: 'ORIGINAL_FILENAME_AND_UUID',
                formatLimit: EXCEL_TYPES.join(','),
            },
            importing: false,
            marketTaskImportRules: {
                uploadExcelFilePath: [
                    { required: true, message: '请选择导入Excel文件!' },
                ],
            },
            marketTaskImportForm: {
                uploadExcelFileName: '',
                uploadExcelFilePath: '',
            },

            // 任务分派
            marketTaskDistributeDialogVisible: false,
            marketTaskDistributeRules: {
                taskId: [
                    {
                        required: true,
                        message: '任务ID不能为空!',
                    },
                ],
                leaderStaffId: [
                    {
                        type: 'number',
                        required: true,
                        message: '请选择团队长!',
                    },
                ],
            },
            marketTaskDistributeForm: {
                taskId: '',
                taskObj: {},
                leaderStaffId: '',
            },

            // 任务详情
            marketTaskViewDialogVisible: false,
            marketTaskViewActiveTabName: 'marketTaskViewBasicInfo',
            marketTaskViewForm: {
                taskId: '',
                taskName: '',
                serviceType: '',
                serviceTypeName: '',
                taxThreshold: '',
                totalAmount: '',
                totalTaxedAmount: '',
                sendOrgName: '',
                sendUserName: '',
                acceptOrgName: '',
                acceptUserName: '',
                status: '',
                statusName: '',
                acceptStatus: '',
                acceptStatusName: '',
                distributeTime: '',
                distributeStatus: '',
                distributeStatusName: '',
                createTime: '',
                updateTime: '',
                tradeOrgIds: [],
            },
            // 任务明细
            taskServiceTargetsLoading: false,
            taskServiceDetailQueryForm: {
                taskId: null,
                pageSize: 10,
                currentPage: 1,
            },
            serviceType: 2,
            taskServiceDetail: [],
            taskServiceDetailTotal: 0,
            // 分派明细
            exportLoading: false,
            taskDistributeDetailsLoading: false,
            taskDistributeDetailQueryForm: {
                pageSize: 10,
                currentPage: 1,
            },
            taskDistributeDetailList: [],
            taskDistributeDetailTotal: 0,
        };
    },
    computed: {
        uploadHeaders() {
            let headers = {
                Accept: 'application/json',
            };
            let accessToken = this.$store.getters.getAccessToken();
            if (accessToken && accessToken.access_token) {
                headers['Authorization'] = 'bearer ' + accessToken.access_token;
            }
            return headers;
        },
        loginUser() {
            return this.$store.state.loginUserAllData.loginUser;
        },
        showMarketTaskQueryPager() {
            if (this.marketTaskQuering || this.marketTaskQueryTotal == 0) {
                return false;
            } else {
                return true;
            }
        },
        isEdit() {
            return !!this.marketTaskEditForm.taskId;
        },
        chooseOrgList() {
            return this.allOrgList.filter(
                (item) => this.publishForm.tradeOrgIds.indexOf(item.orgId) < 0
            );
        },
        marketTaskViewTableHeight() {
            return WINDOW_HEIGHT - 120;
        },
        showTaskDistribQueryPager() {
            if (
                this.taskDistributeDetailsLoading ||
                this.taskDistributeDetailTotal == 0
            ) {
                return false;
            } else {
                return true;
            }
        },
        detailShowDistribute() {
            return (
                this.marketTaskViewForm.distributeStatus == 1 &&
                this.marketTaskViewForm.tradeOrgIds.indexOf(
                    this.loginUser.orgId
                ) ===
                    this.marketTaskViewForm.tradeOrgIds.length - 1
            );
        },
        isTopOrg() {
            return (
                this.marketTaskViewForm.tradeOrgIds.indexOf(
                    this.loginUser.orgId
                ) === 0
            );
        },
        isAll() {
            return this.marketTaskQueryForm.taskQueryType === 'ALL';
        },
    },
    watch: {
        'marketTaskEditForm.totalAmount': function (newVal, oldVal) {
            this.updateTaxedAmount(); //更新总金额
        },
        'marketTaskEditForm.taxThreshold': function (newVal, oldVal) {
            this.updateTaxedAmount(); //更新总金额
        },
    },
    created() {
        this.loadAllOrgList();
        if (this.loginUser.userType == 0) {
            this.marketTaskTabOption = [
                {
                    label: '全部',
                    name: 'ALL',
                },
            ];
        }
    },
    mounted() {
        this.queryMarketTaskList(1000);
    },
    methods: {
        changeTaskTab() {
            this.resetMarketTaskQueryForm();
            this.marketTaskQueryForm.taskQueryType =
                this.marketTaskActiveTabName;
            this.queryMarketTaskList(1000);
        },
        isModifiableMarketTask(row) {
            //当前登录者创建的任务 && 任务状态是已创建待接受状态
            return (
                row.status == 0 &&
                row.sendOrgId == this.loginUser.orgId &&
                row.isDeleted == 0
            );
        },
        isModifiableMarketTask2(row) {
            //当前登录者创建的任务 && 任务状态是已创建待接受状态
            return (
                row.status == 2 &&
                row.sendOrgId == this.loginUser.orgId &&
                row.isDeleted == 0
            );
        },
        isPublishableMarketTask(row) {
            return (
                this.isModifiableMarketTask(row) &&
                row.taskServiceTargetCount > 0
            );
        },
        isPublishableMarketTask2(row) {
            return (
                row.status == 2 &&
                row.sendOrgId == this.loginUser.orgId &&
                row.isDeleted == 0 &&
                row.taskServiceTargetCount > 0
            );
        },
        isDeletableMarketTask(row) {
            return (
                (row.status == 0 || row.status == 1) &&
                row.ownerOrgId == this.loginUser.orgId &&
                !row.acceptUserId &&
                row.isDeleted == 0
            );
        },
        isNoDeletableMarketTask(row) {
            return (
                (row.status == 0 || row.status == 1) &&
                row.ownerOrgId == this.loginUser.orgId &&
                !row.acceptUserId &&
                row.isDeleted == 1
            );
        },
        isAvailableMarketTask(row) {
            if (row.status == 1 && row.isDeleted == 0) {
                let notAvailableOrgIds = [ALL_ORG_ID].concat(row.tradeOrgIds);
                //拥有全部组织ALL_ORG_ID的人不能接受任务 && 本组织不能接受本组织的任务
                return !notAvailableOrgIds.includes(this.loginUser.orgId);
            }
            return false;
        },
        isDistributableMarketTask(row) {
            //当前登录者接受的任务 && 任务状态是已接受待分派状态
            return row.status == 2 && row.sendOrgId == this.loginUser.orgId;
        },
        isUnDistributableMarketTask(row) {
            //当前登录者接受的任务 && 任务状态是已分派状态
            return row.status == 4 && row.sendOrgId == this.loginUser.orgId;
        },
        getMarketStatusTagType(status) {
            if (status == '0') {
                return 'purple';
            } else if (status == '4') {
                return 'success';
            } else {
                return 'lblue';
            }
        },
        getMarketTaskOtherStatusTagType(status) {
            if (status == '0') {
                return 'info';
            } else if (status == '1') {
                return 'success';
            }
        },
        getMarketTaskIsDeletedTagType(status) {
            if (status == '0') {
                return 'success';
            } else if (status == '1') {
                return 'info';
            }
        },
        loadAllOrgList() {
            let url = PLATFORM_API.of('/api/platform/upms/org/all');
            this.$http
                .get(url)
                .then((response) => {
                    let result = response.data;
                    if (result.success) {
                        this.allOrgList = result.data;
                    }
                })
                .catch(defaultApiErrorHandler);
        },
        loadLeaderStaffs(query) {
            if (query) {
                this.leaderStaffQueryLoading = true;
                let url = PLATFORM_API.of('/api/platform/visp/staff/leaders');
                this.$http
                    .get(url, {
                        params: { staffName: query, idcard: query },
                    })
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.leaderStaffQuerySelectOptions = result.data;
                        } else {
                            this.leaderStaffQuerySelectOptions = [];
                        }
                    })
                    .catch((error) => {
                        this.leaderStaffQuerySelectOptions = [];
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        this.leaderStaffQueryLoading = false;
                    });
            }
        },
        clearLeaderStaffQuerySelectOptions() {
            this.leaderStaffQuerySelectOptions = [];
        },
        //任务模块
        queryMarketTaskList(loading) {
            this.marketTaskQueryForm.currentPage = 1;
            this.doQueryMarketTaskList(loading);
        },
        doQueryMarketTaskList(loading) {
            this.marketTaskQuering = true;
            if (loading) {
                this.marketTaskQueryLoading = true;
            }
            setTimeout(() => {
                let params = Object.assign(
                    {},
                    this.marketTaskQueryForm,
                    mapSort(this.marketTaskQuerySort)
                );
                this.$http
                    .get(
                        PLATFORM_API.of('/api/platform/visp/marketTask/list'),
                        {
                            params: params,
                        }
                    )
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.marketTaskList = result.data;
                            this.marketTaskQueryTotal = result.totalRowCount;
                        } else {
                            this.marketTaskList = [];
                            this.marketTaskQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch((error) => {
                        this.marketTaskList = [];
                        this.marketTaskQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.marketTaskQueryLoading = false;
                        }
                        this.marketTaskQuering = false;
                    });
            }, loading);
        },
        resetMarketTaskQueryForm() {
            this.$refs.marketTaskQueryForm.resetFields();
        },
        onMarketTaskQuerySortChange(parameter) {
            if (
                this.marketTaskQuerySort.prop != parameter.prop ||
                this.marketTaskQuerySort.order != parameter.order
            ) {
                this.marketTaskQuerySort.prop = parameter.prop;
                this.marketTaskQuerySort.order = parameter.order;
                this.queryMarketTaskList(1000);
            }
        },
        onMarketTaskQueryPageSizeChange(pageSize) {
            this.marketTaskQueryForm.pageSize = pageSize;
            this.queryMarketTaskList(1000);
        },
        onMarketTaskQueryCurrentPageChange(currentPage) {
            this.marketTaskQueryForm.currentPage = currentPage;
            this.doQueryMarketTaskList(1000);
        },

        handleMarketTaskCommand(cmd, row) {
            if (cmd == 'edit') {
                this.openMarketTaskEditDialog(cmd, row);
            } else if (cmd == 'edit2') {
                this.openMarketTaskEditDialog(cmd, row);
            } else if (cmd == 'publish') {
                this.publishMarketTask(row);
            } else if (cmd == 'view') {
                this.openMarketTaskViewDialog(cmd, row);
            } else if (cmd == 'distribute') {
                this.openMarketTaskDistributeDialog(cmd, row);
            } else if (cmd == 'unDistribute') {
                this.unDistributeTask(row);
            } else if (cmd == 'cancel') {
                this.cancelMarketTask(row);
            } else if (cmd == 'noCancel') {
                this.noCancelMarketTask(row);
            } else if (cmd == 'consume') {
                this.consumeMarketTask(row);
            } else if (cmd == 'unconsume') {
                this.unconsumeMarketTask(row);
            }
        },

        openMarketTaskEditDialog(cmd, row) {
            if (
                (cmd == 'edit' && !this.isModifiableMarketTask(row)) ||
                (cmd == 'edit2' && !this.isModifiableMarketTask2(row))
            ) {
                this.$message.error('该任务正在进行中,不允许修改!');
            } else {
                if (cmd == 'add') {
                    this.canEditInfo = true;
                } else {
                    this.canEditInfo = false;
                }
                this.marketTaskCurrentActionType = cmd;
                this.marketTaskEditDialogVisible = true;
            }

            if (!!row) {
                Vue.nextTick(() => {
                    Object.keys(this.marketTaskEditForm).forEach((name) => {
                        this.marketTaskEditForm[name] = row[name];
                    });
                    if (this.isEdit) {
                        //加载服务明细
                        this.taskServiceDetailQueryForm.taskId = row.taskId;
                        this.loadMarketTaskServiceTargets();
                    }
                });
            }
        },
        saveMarketTask() {
            let url = '';
            let method = 'post';
            if (this.marketTaskEditForm.taskId) {
                url = PLATFORM_API.of('/api/platform/visp/marketTask/update');
                method = 'post';
            } else {
                url = PLATFORM_API.of('/api/platform/visp/marketTask/create');
                method = 'post';
            }
            if (url) {
                this.$refs.marketTaskEditForm.validate((valid) => {
                    if (valid && !this.submiting) {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http[method](url, this.marketTaskEditForm)
                                .then((response) => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.closeMarketTaskEditDialog();
                                        this.$message.success(result.message);
                                        this.queryMarketTaskList(1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1500);
                    } else {
                        return false;
                    }
                });
            }
        },
        closeMarketTaskEditDialog() {
            this.submiting = false;
            this.marketTaskEditDialogVisible = false;

            // reset
            this.$refs.marketTaskEditForm.resetFields();
            Object.keys(this.marketTaskEditForm).forEach((name) => {
                if (Array.isArray(this.marketTaskEditForm[name])) {
                    this.marketTaskEditForm[name] = [];
                } else {
                    this.marketTaskEditForm[name] = '';
                }
            });
            this.marketTaskEditForm.totalAmount = '0';
            this.marketTaskEditForm.amountRange = '750-800';
            this.marketTaskEditForm.taxThreshold = '0';
            this.marketTaskEditForm.totalTaxedAmount = '0';

            this.taskServiceDetailQueryForm.taskId = null;
            this.taskServiceDetailQueryForm.pageSize = 10;
            this.taskServiceDetailQueryForm.currentPage = 1;
            this.serviceType = 2;
            this.taskServiceDetail = [];
            this.taskServiceDetailTotal = 0;
        },

        openMarketTaskImportDialog() {
            this.marketTaskImportDialogVisible = true;
        },
        downloadTemplateExcel() {
            let url = PLATFORM_API.of('/api/xdownload/store/file');
            this.$http
                .post(
                    url,
                    {
                        targetFileName: '任务市场批量导入模板.xlsx',
                        targetFilePath:
                            '/excel/templates/任务市场批量导入模板.xlsx',
                    },
                    {
                        responseType: 'blob', // 设置响应数据类型
                    }
                )
                .then((response) => {
                    let fileblob = new Blob([response.data]);
                    let filename = decodeURI(
                        parseFilename(response.headers['content-disposition'])
                    );
                    FileSaver.saveAs(fileblob, filename);
                })
                .catch(defaultApiErrorHandler);
        },
        beforeImportExcelUpload(file) {
            let fileName = file.name;
            if (fileName.replace(/\s+/g, '') !== fileName) {
                this.$message.error('上传文件名不能包含空格!');
                return false;
            }
            let fileType = fileName
                .substring(fileName.lastIndexOf('.') + 1)
                .toLowerCase();
            if (EXCEL_TYPES.indexOf(fileType) === -1) {
                this.$message.error(
                    '上传文件只能是EXCEL(xls、xlsx)格式的文件!'
                );
                return false;
            }
            if (file.size > 0 && file.size / 1024 / 1024 > 1) {
                this.$message.error('上传EXCEL文件大小不能超过1MB!');
                return false;
            }
            return true;
        },
        handleImportExcelExceed(file, fileList) {
            this.$message.error('最多只能上传一个文件!若要重新上传请先删除.');
            return false;
        },
        handleImportExcelUploadSuccess(response, file, fileList) {
            file.path = response.data.path;
            this.marketTaskImportForm.uploadExcelFileName = response.data.name;
            this.marketTaskImportForm.uploadExcelFilePath = response.data.path;
            this.showMarketTaskImportFeedback = false;
            this.$refs.marketTaskImportForm.validateField(
                'uploadExcelFilePath'
            );
        },
        handleImportExcelRemove(file, fileList) {
            this.showMarketTaskImportFeedback = false;
            this.marketTaskImportForm.uploadExcelFileName = '';
            this.marketTaskImportForm.uploadExcelFilePath = '';
            if (file && file.path) {
                this.$http.get(
                    PLATFORM_API.of(
                        '/api/xupload/protected/remove?path=' + file.path
                    )
                );
            }
        },
        handleUploadError(error, file, fileList) {
            try {
                let result = JSON.parse(error.message);
                this.$message.error(result.message);
            } catch (e) {
                console.error(e);
            }
        },
        importMarketTask() {
            let url = PLATFORM_API.of(
                '/api/platform/visp/marketTask/importBatch'
            );
            this.$refs.marketTaskImportForm.validate((valid) => {
                if (valid && !this.importing) {
                    this.importing = true;
                    this.$http
                        .post(url, this.marketTaskImportForm)
                        .then((response) => {
                            let result = response.data;
                            if (result.success) {
                                this.closeMarketTaskImportDialog();
                                this.$message.success(result.message);
                                this.queryMarketTaskList(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            defaultApiErrorHandler.call(
                                this,
                                error,
                                (result) => {
                                    if (result.code == 400) {
                                        this.showMarketTaskImportFeedback = true;
                                    }
                                }
                            );
                        })
                        .then(() => {
                            this.importing = false;
                        });
                } else {
                    return false;
                }
            });
        },
        downloadFeedbackExcel() {
            let url = PLATFORM_API.of('/api/xdownload/temp/file');
            this.$http
                .post(
                    url,
                    {
                        targetFileName:
                            this.marketTaskImportForm.uploadExcelFileName,
                        targetFilePath:
                            this.marketTaskImportForm.uploadExcelFilePath,
                    },
                    {
                        responseType: 'blob', // 设置响应数据类型
                    }
                )
                .then((response) => {
                    let fileblob = new Blob([response.data]);
                    let filename = decodeURI(
                        parseFilename(response.headers['content-disposition'])
                    );
                    FileSaver.saveAs(fileblob, filename);
                })
                .catch(defaultApiErrorHandler);
        },
        closeMarketTaskImportDialog() {
            this.marketTaskImportDialogVisible = false;
            this.showMarketTaskImportFeedback = false;
            this.$refs.marketTaskImportForm.resetFields();
            this.$refs.marketTaskImportUploader.clearFiles();
        },

        cancelMarketTask(row) {
            let url = PLATFORM_API.of(
                '/api/platform/visp/marketTask/cancel/' + row.taskId
            );
            if (this.isDeletableMarketTask(row)) {
                this.$confirm('您确定要作废该任务?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.$http
                        .post(url)
                        .then((response) => {
                            let result = response.data;
                            if (result.success) {
                                this.$message.success(result.message);
                                this.queryMarketTaskList(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch(defaultApiErrorHandler);
                });
            } else {
                this.$message.error('该任务正在进行中,不允许作废!');
            }
        },

        noCancelMarketTask(row) {
            let url = PLATFORM_API.of(
                '/api/platform/visp/marketTask/noCancel/' + row.taskId
            );
            this.$http
                .post(url)
                .then((response) => {
                    let result = response.data;
                    if (result.success) {
                        this.$message.success(result.message);
                        this.queryMarketTaskList(1000);
                    } else {
                        this.$message.error(result.message);
                    }
                })
                .catch(defaultApiErrorHandler);
        },

        publishMarketTask(row) {
            this.publishForm.taskId = row.taskId;
            this.publishForm.tradeOrgIds = row.tradeOrgIds;
            this.publishForm.orgId = null;
            this.$confirm('是否指定接包机构?', '提示', {
                confirmButtonText: '直接发包',
                cancelButtonText: '指定机构',
                type: 'warning',
            })
                .then(() => {
                    this.publish();
                })
                .catch(() => {
                    this.isChoseOrg = true;
                });
        },
        publish() {
            this.submiting = true;
            let url = PLATFORM_API.of(
                `/api/platform/visp/marketTask/publish/${
                    this.publishForm.taskId
                }/${this.publishForm.orgId || 0}`
            );
            this.$http
                .post(url)
                .then((response) => {
                    let result = response.data;
                    if (result.success) {
                        this.closeChoseOrg();
                        this.$message.success(result.message);
                        this.queryMarketTaskList(1000);
                    } else {
                        this.$message.error(result.message);
                    }
                })
                .catch(defaultApiErrorHandler)
                .finally(() => {
                    this.submiting = false;
                });
        },
        closeChoseOrg() {
            if (this.isChoseOrg) {
                this.$refs.publishForm.resetFields();
                this.publishForm.taskId = null;
                this.publishForm.orgId = null;
                this.publishForm.tradeOrgIds = [];
                this.isChoseOrg = false;
            }
        },

        consumeMarketTask(row) {
            let url = PLATFORM_API.of(
                '/api/platform/visp/marketTask/accept/' + row.taskId
            );
            if (row.status == 1) {
                this.$confirm('您确定要接受该任务?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.$http
                        .post(url)
                        .then((response) => {
                            let result = response.data;
                            if (result.success) {
                                this.$message.success(result.message);
                                this.marketTaskActiveTabName = 'MY';
                                this.changeTaskTab();
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch(defaultApiErrorHandler);
                });
            } else {
                this.$message.error('该任务已经被接受过了!');
            }
        },

        unconsumeMarketTask(row) {
            let url = PLATFORM_API.of(
                '/api/platform/visp/marketTask/undo/' + row.taskId
            );
            if (row.status == 2) {
                this.$confirm('您确定要取消接受该任务?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.$http
                        .post(url)
                        .then((response) => {
                            let result = response.data;
                            if (result.success) {
                                this.$message.success(result.message);
                                this.queryMarketTaskList(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch(defaultApiErrorHandler);
                });
            } else {
                this.$message.error('仅已接受的任务可取消接受!');
            }
        },

        updateTaxedAmount() {
            if (
                (!!this.marketTaskEditForm.ownerOrgId &&
                    this.loginUser.orgId !=
                        this.marketTaskEditForm.ownerOrgId) ||
                (!!this.marketTaskEditForm.ownerId &&
                    this.loginUser.userId != this.marketTaskEditForm.ownerId)
            ) {
                let totalTaxedAmount =
                    (this.marketTaskEditForm.totalTaxedAmount || 0) * 100;
                let taxThreshold =
                    (this.marketTaskEditForm.taxThreshold || 0) * 100;
                this.marketTaskEditForm.totalAmount = (
                    (totalTaxedAmount * 100) /
                    (taxThreshold + 10000)
                ).toFixed(2);
            } else {
                let totalAmount =
                    (this.marketTaskEditForm.totalAmount || 0) * 100;
                let taxThreshold =
                    (this.marketTaskEditForm.taxThreshold || 0) * 100;
                this.marketTaskEditForm.totalTaxedAmount = (
                    (totalAmount * (taxThreshold + 10000)) /
                    1000000
                ).toFixed(2);
            }
        },

        loadMarketTaskServiceTargets() {
            this.taskServiceTargetsLoading = true;
            let url = PLATFORM_API.of(
                `/api/platform/visp/marketTask/detail/${this.taskServiceDetailQueryForm.taskId}/${this.marketTaskActiveTabName}`
            );
            this.$http
                .get(url, {
                    params: this.taskServiceDetailQueryForm,
                })
                .then((response) => {
                    let result = response.data;
                    if (result.success) {
                        this.serviceType =
                            result.data.length > 0
                                ? result.data[0].serviceType
                                : 2;
                        this.taskServiceDetail = result.data;
                        this.taskServiceDetailTotal = result.totalRowCount;
                    } else {
                        this.serviceType = 2;
                        this.taskServiceDetail = [];
                        this.taskServiceDetailTotal = 0;
                        this.$message.error(result.message);
                    }
                })
                .catch((error) => {
                    this.serviceType = 2;
                    this.taskServiceDetail = [];
                    this.taskServiceDetailTotal = 0;
                    defaultApiErrorHandler.call(this, error);
                })
                .then(() => {
                    this.taskServiceTargetsLoading = false;
                });
        },
        onTaskServiceDetailQueryPageSizeChange(pageSize) {
            this.taskServiceDetailQueryForm.pageSize = pageSize;
            this.loadMarketTaskServiceTargets();
        },
        onTaskServiceDetailQueryPageChange(currentPage) {
            this.taskServiceDetailQueryForm.currentPage = currentPage;
            this.loadMarketTaskServiceTargets();
        },
        loadMarketTaskDistribDetails() {
            this.taskDistributeDetailsLoading = true;

            let params = Object.assign(
                { taskId: this.marketTaskViewForm.taskId },
                this.taskDistributeDetailQueryForm
            );
            let url = PLATFORM_API.of(
                '/api/platform/visp/marketTask/distribDetail'
            );
            setTimeout(() => {
                this.$http
                    .get(url, {
                        params: params,
                    })
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.taskDistributeDetailList = result.data;
                            this.taskDistributeDetailTotal =
                                result.totalRowCount;
                        } else {
                            this.taskDistributeDetailList = [];
                            this.taskDistributeDetailTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch((error) => {
                        this.taskDistributeDetailList = [];
                        this.taskDistributeDetailTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        this.taskDistributeDetailsLoading = false;
                    });
            }, 1000);
        },
        onTaskDistribQueryPageSizeChange(pageSize) {
            this.taskDistributeDetailQueryForm.pageSize = pageSize;
            this.loadMarketTaskDistribDetails();
        },
        onTaskDistribQueryPageChange(currentPage) {
            this.taskDistributeDetailQueryForm.currentPage = currentPage;
            this.loadMarketTaskDistribDetails();
        },

        openMarketTaskDistributeDialog(cmd, row) {
            this.marketTaskCurrentActionType = cmd;
            this.marketTaskDistributeDialogVisible = true;
            this.marketTaskDistributeForm.taskId = row.taskId;
            this.marketTaskDistributeForm.taskObj = row;
        },
        closeMarketTaskDistributeDialog() {
            this.marketTaskDistributeDialogVisible = false;
            this.$refs.marketTaskDistributeForm.resetFields();
            this.marketTaskDistributeForm.taskId = '';
            this.marketTaskDistributeForm.taskObj = {};
        },
        distributeMarketTask() {
            let url = PLATFORM_API.of(
                '/api/platform/visp/marketTask/distribute/' +
                    this.marketTaskDistributeForm.taskId +
                    '/' +
                    this.marketTaskDistributeForm.leaderStaffId
            );
            this.$refs.marketTaskDistributeForm.validate((valid) => {
                if (valid && !this.submiting) {
                    this.$confirm('您确定要分派该任务吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }).then(() => {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http
                                .post(url, {})
                                .then((response) => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.closeMarketTaskDistributeDialog();
                                        this.$message.success(result.message);
                                        this.queryMarketTaskList(1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1000);
                    });
                } else {
                    return false;
                }
            });
        },
        unDistributeTask(row) {
            let url = PLATFORM_API.of(
                '/api/platform/visp/marketTask/unDistribute/' + row.taskId
            );
            if (this.isUnDistributableMarketTask(row)) {
                this.$confirm('您确定要取消分派?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.$http
                        .post(url)
                        .then((response) => {
                            let result = response.data;
                            if (result.success) {
                                this.$message.success(result.message);
                                this.queryMarketTaskList(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch(defaultApiErrorHandler);
                });
            } else {
                this.$message.error('该任务正在进行中,不允许取消分派!');
            }
        },
        openMarketTaskViewDialog(cmd, row) {
            this.marketTaskCurrentActionType = cmd;
            this.marketTaskViewDialogVisible = true;
            if (cmd == 'service') {
                this.marketTaskViewActiveTabName =
                    'marketTaskViewServiceDetail';
            } else if (cmd == 'summary') {
                this.marketTaskViewActiveTabName = 'marketTaskViewSummary';
            } else {
                this.marketTaskViewActiveTabName = 'marketTaskViewBasicInfo';
            }
            Vue.nextTick(() => {
                Object.keys(this.marketTaskViewForm).forEach((name) => {
                    this.marketTaskViewForm[name] = row[name];
                });
                //加载服务明细
                this.taskServiceDetailQueryForm.taskId = row.taskId;
                this.loadMarketTaskServiceTargets();
                // 加载分派明细
                if (this.detailShowDistribute) {
                    this.loadMarketTaskDistribDetails();
                }
            });
        },
        closeMarketTaskViewDialog() {
            this.marketTaskViewDialogVisible = false;
            Object.keys(this.marketTaskViewForm).forEach((name) => {
                if (Array.isArray(this.marketTaskViewForm[name])) {
                    this.marketTaskViewForm[name] = [];
                } else {
                    this.marketTaskViewForm[name] = '';
                }
            });

            this.taskServiceDetailQueryForm.taskId = null;
            this.taskServiceDetailQueryForm.pageSize = 10;
            this.taskServiceDetailQueryForm.currentPage = 1;
            this.serviceType = 2;
            this.taskServiceDetail = [];
            this.taskServiceDetailTotal = 0;

            this.taskDistributeDetailQueryForm.pageSize = 10;
            this.taskDistributeDetailQueryForm.currentPage = 1;
            this.taskDistributeDetailList = [];
            this.taskDistributeDetailTotal = 0;
        },
        // 导出明细
        exportTaskDetails(type) {
            this.submiting = true;
            let url = PLATFORM_API.of(
                '/api/platform/visp/marketTask/exportTaskDetails'
            );
            let params = Object.assign({
                taskId: this.marketTaskViewForm.taskId,
                exportType: type,
            });
            this.$http
                .post(url, params, {
                    responseType: 'blob', // 设置响应数据类型
                })
                .then((response) => {
                    let fileblob = new Blob([response.data]);
                    let filename = decodeURI(
                        parseFilename(response.headers['content-disposition'])
                    );
                    FileSaver.saveAs(fileblob, filename);
                })
                .catch((error) => {
                    if (error.response.status === 500) {
                        this.$message.error('暂无任务明细!');
                    }
                })
                .finally(() => {
                    this.submiting = false;
                });
        },
    },
};
</script>
<style lang='scss'>
.x-task-remark {
    line-height: 60px !important;
    font-size: 14px;
    color: #729e08;
    float: right;
}

.org-select-option,
.leader-select-option,
.platenumber-select-option {
    .option-left {
        float: left;
        color: $--color-primary;
        font-size: 13px;
        padding-right: 50px;
    }

    .option-right {
        float: right;
    }
}

.task-service-detail-tag {
    margin-right: 5px;
}

.task-consume-link {
    color: $--color-green !important;
}

.task-distribute-link {
    color: $--color-green !important;
}

.import-success {
    margin-top: 10px;
    padding: 10px;
    line-height: 1.5;
    background-color: mix($--color-white, $--color-success, 90%);
    border-radius: 4px;
    font-size: 13px;
    color: $--color-success;
}

.import-feedback {
    margin-top: 10px;
    padding: 10px;
    line-height: 1.5;
    background-color: mix($--color-white, $--color-danger, 90%);
    border-radius: 4px;
    font-size: 13px;
    color: $--color-danger;

    a {
        color: $--color-blue;
    }
}
</style>